<nb-card class="col-sm-12 " style="width:500px; min-height: 300px; background-color: aliceblue;">
    <nb-card-header style="text-align: center;">
    <u><b>File Info</b></u>
        <button class="btn btn-warning float-right" status="info" size="small" nbButton outline (click)="cancel()"><nb-icon
                icon="close-square-outline"></nb-icon>
        </button>
    </nb-card-header>
    <nb-card-body>

        <div class="form-group">
            <div class="row">
                <ng-container>
                    <div class="form-group">
                        <label><strong>File Name:</strong></label><br>
                        {{fileName}}
                    </div>
                </ng-container>
            </div>

            <div class="row">
                <ng-container>
                    <div class="form-group">
                        <label><strong>Project Name:</strong></label><br>
                        {{projectName}}
                    </div>
                </ng-container>
            </div>

            <div class="row">
                <ng-container>
                    <div class="form-group">
                        <label><strong>Project Owner:</strong></label><br>
                        {{owner}}
                    </div>
                </ng-container>
            </div>
        </div>

    </nb-card-body>
</nb-card>